require('./wizard-progress.less');

module.exports = {
    namespace: "progtrckr",
    done: 'progtrckr-done',
    todo: 'progtrckr-todo',
    doing: 'progtrckr-doing'
}


/** WEBPACK FOOTER **
 ** ./src/styles/WizardProgressTemplate-style.js
 **/